import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Navbar from './layout/navbar/Navbar';
import { Suspense, lazy, useEffect, useState } from 'react';

const Home = lazy(() => import('./Pages/Dashboard/Home'));
const RestoLogin = lazy(() => import('./Pages/RestoAccount/RestoLogin'));
const ContactUs = lazy(() => import('./Pages/RestoAccount/ContactUs/ContactUs'));
const AddMenu = lazy(() => import('./Pages/RestoAccount/AddMenu/AddMenu'));
const GetWaiters = lazy(() => import('./Pages/RestoAccount/AssignTablesToWaiter/GetWaiters'));
const AssignTablesToWaiter = lazy(() => import('./Pages/RestoAccount/AssignTablesToWaiter/AssignTablesToWaiter'));
const GetSurveys = lazy(() => import('./Pages/RestoAccount/GetSurveys/GetSurveys'));
const MoreAnalytics = lazy(() => import('./Pages/RestoAccount/MoreAnalytics/MoreAnalytics'));
const ViewTables = lazy(() => import('./Pages/RestoAccount/ViewTables/ViewTables'));
const AddTablet2 = lazy(() => import('./Pages/RestoAccount/ViewTables/AddTablet2'));
const RestoForgotPassword = lazy(() => import('./Pages/RestoAccount/RestoForgotPassword'));
const RestoForgotPassword2 = lazy(() => import('./Pages/RestoAccount/RestoForgotPassword2'));
const CustomerData = lazy(() => import('./Pages/RestoAccount/CustomerData/CustomerData'));

/**
 * Forward the retired /Wallet route into Customer Insights, query string intact.
 *
 * Whish sends a paying customer back to `/Wallet?order=…&payment=…`, and that
 * URL is configured server-side (WHISH_APP_PUBLIC_URL) and baked into orders
 * already in flight. Dropping the route would strand a real payment on a 404
 * with the money taken, so it redirects instead of disappearing — and it must
 * carry `search` through, since the order id is the whole point.
 */
const WalletRedirect = () => (
  <Navigate to={`/CustomerData${window.location.search}`} replace />
);

function App() {
  const [restoToken, setRestoToken] = useState(localStorage.getItem('restoToken') || '');

  useEffect(() => {
    const updateToken = () => setRestoToken(localStorage.getItem('restoToken') || '');
    window.addEventListener('storage', updateToken);
    window.addEventListener('authChange', updateToken);
    return () => {
      window.removeEventListener('storage', updateToken);
      window.removeEventListener('authChange', updateToken);
    };
  }, []);

  return (
    <div className="App">
      <Router>
        <Navbar />
        <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={restoToken ? <Home /> : <Navigate to="/RestoLogin" replace />} />
          {restoToken ?
            <>
              <Route path="/RestoLogin" element={<Navigate to="/" replace />} />
              <Route path="/ContactUs" element={<ContactUs />} />
              <Route path="/AddMenu" element={<AddMenu />} />
              <Route path="/GetWaiters" element={<GetWaiters />} />
              <Route path="/AssignTablesToWaiter/:id" element={<AssignTablesToWaiter />} />
              <Route path="/GetSurveys" element={<GetSurveys />} />
              <Route path="/ViewTables" element={<ViewTables />} />
              <Route path="/AddTablet2" element={<AddTablet2 />} />
              <Route path="/MoreAnalytics" element={<MoreAnalytics />} />
              <Route path="/CustomerData" element={<CustomerData />} />
              {/**
                * The wallet lives inside Customer Insights now, but /Wallet must
                * keep working: it is the URL Whish redirects a paying customer
                * back to (WHISH_APP_PUBLIC_URL + /Wallet?order=…), and it is in
                * browser histories and bookmarks. `WalletRedirect` forwards the
                * query string, so a returning payment still finds its order.
                */}
              <Route path="/Wallet" element={<WalletRedirect />} />
            </>
            :
            <>
              <Route path="/RestoForgotPassword" element={<RestoForgotPassword />} />
              <Route path="/RestoForgotPassword2" element={<RestoForgotPassword2 />} />
              <Route path="/RestoLogin" element={<RestoLogin />} />
              <Route path="/ContactUs" element={<RestoLogin />} />
              <Route path="/AddMenu" element={<RestoLogin />} />
              <Route path="/GetWaiters" element={<RestoLogin />} />
              <Route path="/AssignTablesToWaiter/:id" element={<RestoLogin />} />
              <Route path="/GetSurveys" element={<RestoLogin />} />
              <Route path="/ViewTables" element={<RestoLogin />} />
              <Route path="/AddTablet2" element={<RestoLogin />} />
              <Route path="/MoreAnalytics" element={<RestoLogin />} />
              <Route path="/CustomerData" element={<RestoLogin />} />
              <Route path="/Wallet" element={<RestoLogin />} />
            </>
          }
        </Routes>
        </Suspense>
      </Router>
    </div>
  );
}

export default App;
